import Box from "@mui/material/Box"
import Skeleton from "@mui/material/Skeleton"
import Stack from "@mui/material/Stack"

/**
 * Skeleton de tabla mostrado mientras se cargan los comprobantes.
 * Simula una toolbar, encabezado y varias filas.
 */
function LoadingTable({ rows = 8, columns = 8 }) {
  return (
    <Box sx={{ p: 2 }}>
      {/* Toolbar simulada */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Skeleton variant="rounded" width={280} height={40} />
        <Stack direction="row" spacing={1}>
          {Array.from({ length: 4 }).map((_, index) => (
            <Skeleton key={index} variant="circular" width={36} height={36} />
          ))}
        </Stack>
      </Stack>

      {/* Encabezado simulado */}
      <Stack direction="row" spacing={2} sx={{ mb: 1.5 }}>
        {Array.from({ length: columns }).map((_, index) => (
          <Skeleton key={index} variant="text" sx={{ flex: 1, fontSize: "1.1rem" }} />
        ))}
      </Stack>

      {/* Filas simuladas */}
      <Stack spacing={1.25}>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <Stack key={rowIndex} direction="row" spacing={2} alignItems="center">
            {Array.from({ length: columns }).map((_, colIndex) => (
              <Skeleton
                key={colIndex}
                variant="rounded"
                height={28}
                sx={{ flex: 1, borderRadius: 1 }}
              />
            ))}
          </Stack>
        ))}
      </Stack>
    </Box>
  )
}

export default LoadingTable
